module.exports = __webpack_public_path__ + "static/icons/person-10.7c49c8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nps/person-10.svg
// module id = 2om1
// module chunks = 1